import { __spreadArray, __assign } from 'tslib';
import React__default from 'react';
import { KpkFilterModifierType } from '@keepeek/commons';
import { ButtonBase, Typography, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import StyledFilterCheckbox, { classes } from './index.styled.js';

var FilterCheckbox = function (_a) {
    var _b;
    var filter = _a.filter, className = _a.className, _c = _a.defaultMaxItemsToShow, defaultMaxItemsToShow = _c === void 0 ? 10 : _c, onFilterUpdate = _a.onFilterUpdate, expanded = _a.expanded, setExpanded = _a.setExpanded, sx = _a.sx, KIcon = _a.KIcon;
    var _d = React__default.useState(defaultMaxItemsToShow), maxItemsToShow = _d[0], setMaxItemsToShow = _d[1];
    var t = useTranslation("refront-components").t;
    var isItemsOverflow = filter.values && filter.values.length > maxItemsToShow && maxItemsToShow !== -1;
    var items = isItemsOverflow ? __spreadArray([], filter.values, true).splice(0, maxItemsToShow) : filter.values;
    // not empty modifier is used to have an advanced search based on the value of the filter that is not empty
    var isModifierTypeNotEmpty = ((_b = filter.modifiers) === null || _b === void 0 ? void 0 : _b.some(function (m) { return m.type === KpkFilterModifierType.NotEmpty && !!m.selected; })) ||
        false;
    var selectUnselectAll = function () {
        var updatedValues = filter.values.map(function (value) { return (__assign(__assign({}, value), { 
            // invert selection:
            selected: !isModifierTypeNotEmpty })); });
        onFilterUpdate(__assign(__assign({}, filter), { modifiers: [
                {
                    // invert modifier type:
                    type: isModifierTypeNotEmpty
                        ? KpkFilterModifierType.ContainsOne
                        : KpkFilterModifierType.NotEmpty,
                    selected: true
                },
            ], values: updatedValues }));
    };
    function handleChange(filterValueId, checked) {
        var _a;
        var newValues = filter.values.map(function (v) {
            if ("".concat(v.id) === "".concat(filterValueId)) {
                return __assign(__assign({}, v), { selected: checked });
            }
            else {
                return __assign({}, v);
            }
        });
        // detect when user check all values : switch to multiSelect mode :
        if (newValues.every(function (v) { return !!v.selected; })) {
            selectUnselectAll();
            return;
        }
        onFilterUpdate(__assign(__assign({}, filter), { modifiers: ((_a = filter.modifiers) === null || _a === void 0 ? void 0 : _a.map(function (m) {
                return __assign(__assign({}, m), { selected: m.type === KpkFilterModifierType.ContainsOne });
            })) || null, values: newValues }));
    }
    function getIconComponent(iconName) {
        if (KIcon) {
            return React__default.createElement(KIcon, { sx: { fontSize: "0.9rem" }, className: iconName });
        }
        else {
            return React__default.createElement(DefaultIcon, { sx: { fontSize: "0.9rem" }, className: iconName });
        }
    }
    return (React__default.createElement(StyledFilterCheckbox, { className: clsx("FilterCheckbox", className), filter: filter, expanded: expanded, setExpanded: setExpanded, expandIcon: getIconComponent("fa-caret-down"), sx: sx },
        items.length > 1 && (React__default.createElement(ButtonBase, { onClick: selectUnselectAll, focusRipple: true, className: classes.multiSelect },
            isModifierTypeNotEmpty
                ? getIconComponent("fa-sm fa-angles-left")
                : getIconComponent("fa-sm fa-angles-right"),
            React__default.createElement(Typography, { variant: "caption", sx: { marginLeft: function (theme) { return theme.spacing(0.5); } } }, isModifierTypeNotEmpty
                ? t("components.filter-checkbox.check.none.label")
                : t("components.filter-checkbox.check.all.label")))),
        React__default.createElement(FormGroup, { className: classes.formGroup },
            items.map(function (_a) {
                var id = _a.id, label = _a.label, title = _a.title, selected = _a.selected;
                return (React__default.createElement(FormControlLabel, { key: id, control: React__default.createElement(Checkbox, { classes: { root: classes.input }, checked: !!selected, onChange: function (_, checked) { return handleChange(id, checked); }, name: label, title: title || label, size: "small" }), label: React__default.createElement(Typography, { variant: "caption", noWrap: true, display: "block", title: title || label, className: classes.label }, label), className: classes.formControlLabel }));
            }),
            isItemsOverflow && maxItemsToShow !== -1 && (React__default.createElement(ButtonBase, { sx: { alignSelf: "baseline", paddingTop: function (theme) { return theme.spacing(1); } }, onClick: function () { return setMaxItemsToShow(-1); }, focusRipple: true },
                getIconComponent("fa-sm fa-chevron-down"),
                React__default.createElement(Typography, { variant: "caption", noWrap: true, sx: { marginLeft: function (theme) { return theme.spacing(0.5); } } }, t("components.filter-checkbox.more.choice.label")))),
            maxItemsToShow === -1 && (React__default.createElement(ButtonBase, { focusRipple: true, sx: { alignSelf: "baseline", paddingTop: function (theme) { return theme.spacing(1); } }, onClick: function () { return setMaxItemsToShow(10); } },
                getIconComponent("fa-sm fa-chevron-up"),
                React__default.createElement(Typography, { variant: "caption", noWrap: true, sx: { marginLeft: function (theme) { return theme.spacing(0.5); } } }, t("components.filter-checkbox.less.choice.label")))))));
};

export { FilterCheckbox as default };
//# sourceMappingURL=index.js.map
